import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import CalendarPage from '../pages/CalendarPage';

const MainLayout: React.FC = () => {
  return (
    <div className="main-layout">
      <div className="main-layout__content">
        <Routes>
          <Route path="/" element={<Navigate to="/calendar" replace />} />
          <Route path="/calendar/:date?" element={<CalendarPage />} />
        </Routes>
      </div>
    </div>
  );
};

export default MainLayout;
